// @flow
import { SMART_FAQ } from 'Client/cms/toolkit/constants';
import { SmartFaqLine } from 'Components/lines/smart-faq-line/SmartFaqLine';

export const smartFaqDescriptor = {
  name: SMART_FAQ,
  component: SmartFaqLine,
};
